import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import EventPopupWidget from './EventPopupWidget';

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-bg-light">
      <Header />
      <EventPopupWidget />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
